import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  height: 100vh;
  flex: 1;
`;

export const InputContainer = styled.div`
  padding-left: 24px;
  margin-right: 16px;
  display: flex;
  flex-direction: row;
`;

export const DestinationInputView = styled.div`
  padding-bottom: 10px;
`;

export const ClearButton = styled.span`
  font-family: 'Rubik';
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.12px;
  color: #008cff;
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  box-shadow: rgb(0, 0, 0) 0px 2px 4px;
  z-index: 0;
`;

export const BackArrow = styled.img`
  width: 15px;
  height: 15px;
`;

export const Label = styled.span`
  font-family: 'Rubik';
  font-weight: 700;
  font-size: 12px;
  color: #9b9b9b;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 5px;
`;

export const BottomLine = styled.div`
  border: solid 1px #008cff;
  margin: 4px 20px 0;
  margin-top: 4px;
`;

export const Width90 = styled.div`
  width: 90%;

  .destinationInput {
    font-family: 'Rubik';
    font-weight: 700;
    font-size: 18px;
    color: #4a4a4a;
    width: 100%;
  }
`;

export const CityListItem = styled.div`
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
`;

export const CityListItemPrimaryTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CityListItemPrimaryText = styled.span`
  font-size: 16px;
  color: #000000;
  font-family: 'Rubik';
  font-weight: 300;
`;

export const CityListItemMatchedPrimaryText = styled.span`
  font-size: 16px;
  color: #000000;
  font-family: 'Rubik';
  font-weight: 700;
`;

export const CityListItemSecondaryText = styled.span`
  font-size: 12px;
  color: #9b9b9b;
  font-family: 'Rubik';
  font-weight: 400;
`;
